import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import { getParRateFormulaByType, getParRateFormulaByTypeParams, getParRateFormulaListbyCriteria, GetParRateFormulaListbyCriteriaParams, ParRateFormulaByTypeResponse, ParRateFormulaResponse } from 'services/parametersService';


export type RateFormulaSelectByCriteriaProps = SelectProps<any> &{
  params: GetParRateFormulaListbyCriteriaParams;
  value?:   ParRateFormulaResponse;
  onChange?: (formularate?:ParRateFormulaResponse) => void;
  onSelected?: (formularate: ParRateFormulaResponse) => void;

  disabled?: boolean;
  allowClear?:boolean;
  style?: any;
};

const RateFormulaSelectByCriteria = ({
  params,
  value,
  onChange = noop,
  onSelected,
  ...otherProps
}:RateFormulaSelectByCriteriaProps) => {
  const { data: formularate,isLoading } = useQuery(
    ['getParRateFormulaListbyCriteria', params],
    () => getParRateFormulaListbyCriteria(params).then((res) => res.list || []),
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(formularate?.find((item) => item.formulacode === value)!);
    }
  };
  return (
    <Select onChange={handleChange} value={value} {...otherProps} loading={isLoading} allowClear>
      {formularate?.map((formularate) => (
        <Select.Option value={formularate.formulacode} key={formularate.formulacode}>
          {formularate.formulalabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default RateFormulaSelectByCriteria;
